import { AdminStore } from 'stylemix-vue-admin'

export default {
  created() {
    // This hook should only be executed for root component
    if (this.$root !== this) {
      return
    }

    this.$on('account-loaded', account => {
      // For company users get division from account data
      if (account.division && !this.$allows('administer')) {
        this.$store.commit('zones/setCurrentDivision', account.division)
        return
      }

      let currentDivision = localStorage.getItem(`taxi-admin.current-division`)
      if (currentDivision) {
        this.$store.commit(
          'zones/setCurrentDivision',
          JSON.parse(currentDivision),
        )
      }

      AdminStore.dispatch('zones/fetchCountryZones').then(result => {
        if (!this.$store.state.zones.currentDivision && result[0]) {
          this.$store.commit('zones/setCurrentDivision', result[0])
        }
      })
    })
  },
}
